// removed by extract-text-webpack-plugin
module.exports = {"container":"_2hoMZWBdi_yxgi2c3AYNX","state":"zZXOF8NLH0IJrFFJf7yON"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Buttons/OwnerButtons/styles.css
// module id = 2832
// module chunks = 0